"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DateUtil = /*#__PURE__*/function () {
  function DateUtil() {
    _classCallCheck(this, DateUtil);
  }

  _createClass(DateUtil, null, [{
    key: "getDateAsString",
    value: function getDateAsString(date) {
      var timezoneId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Asia/Tokyo';
      return (0, _momentTimezone.default)(date).tz(timezoneId).format('YYYY-MM-DD');
    }
  }, {
    key: "convertUtcTimezone",
    value: function convertUtcTimezone(date) {
      var timezoneId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Asia/Tokyo';
      return _momentTimezone.default.utc(date).tz(timezoneId).toDate();
    }
  }, {
    key: "parse",
    value: function parse(stringOrDate) {
      var _moment = (0, _momentTimezone.default)(stringOrDate);

      if (!isNaN(_moment)) return _moment.toDate();
      return undefined;
    }
  }, {
    key: "isActive",
    value: function isActive(startDate, endDate) {
      var start = startDate ? (0, _momentTimezone.default)(startDate) : (0, _momentTimezone.default)(new Date(0));
      var end = endDate ? (0, _momentTimezone.default)(endDate) : (0, _momentTimezone.default)(new Date(8640000000000000));
      return (0, _momentTimezone.default)().isBetween(start, end);
    }
  }, {
    key: "isExpired",
    value: function isExpired(expiryDate) {
      return (0, _momentTimezone.default)().isAfter(expiryDate);
    }
  }, {
    key: "currentDateUTC",
    value: function currentDateUTC() {
      return (0, _momentTimezone.default)().utc().format('YYYY-MM-DD HH:mm:ss');
    }
  }, {
    key: "currentDateTime",
    value: function currentDateTime() {
      return (0, _momentTimezone.default)().format('YYYY-MM-DD HH:mm:ss');
    }
  }, {
    key: "expiredAt45s",
    value: function expiredAt45s() {
      return (0, _momentTimezone.default)().tz('Asia/Singapore').format('YYYY-MM-DD HH:mm:ss');
    }
  }, {
    key: "format",
    value: function format(date) {
      var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
      return (0, _momentTimezone.default)(date).format(pattern);
    }
  }, {
    key: "toUnixTimestamp",
    value: function toUnixTimestamp(date) {
      if (date instanceof Date) {
        return (date.getTime() / 1000).toFixed(0);
      }

      return undefined;
    }
  }]);

  return DateUtil;
}();

exports.default = DateUtil;